import React, {createRef} from 'react';

export default function Paragraph(props) {

    const paragraphRef = createRef();

    const data = props.data;
    const updateFormData = props.updateFormData;

    return <div id={data.id} className="sendiio-form-paragraph-element">
        <p  ref={paragraphRef}
            className="sendiio-form-paragraph-p cursor-text"
            placeholder="Type a paragraph"
            format="text"
            contentEditable={true}
            suppressContentEditableWarning={true}
            onBlur={e => {

                if(data.text !== e.currentTarget.textContent){

                    data.text = e.currentTarget.textContent;

                    updateFormData(data);

                    paragraphRef.current.textContent = e.currentTarget.textContent;

                }

            }}
            dangerouslySetInnerHTML={{__html: data.text}} />
    </div>

}